// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-grads[data-v-52d62cf0],.header-color[data-v-52d62cf0]{background-image:-webkit-gradient(linear,left top,right top,from(#3a1c71),color-stop(51%,#d76d77),to(#3a1c71));background-image:linear-gradient(90deg,#3a1c71 0,#d76d77 51%,#3a1c71)}.text-font[data-v-52d62cf0]{font-size:14px}", ""]);
// Exports
module.exports = exports;
